import { SchoolProperty, SchoolPropertyCategory } from '@schooly/api';
import { SchoolPropertyType } from '@schooly/constants';
import React from 'react';

export enum SchoolTuneStatusModalMode {
  STUDENTS = 'students',
  STAFF = 'staff',
}

export type SchoolTuneStatusCategory = Partial<SchoolPropertyCategory> & {
  order: number;
  name: string;
};

export interface SchoolTuneStatus extends Partial<Omit<SchoolProperty, 'category'>> {
  originId?: string;
  replaceId?: string;
  category: SchoolTuneStatusCategory;
}

export const isSchoolTuneStatus = (
  property: SchoolProperty,
): property is SchoolProperty & { category: SchoolTuneStatusCategory } => {
  return !!property.category && property.type === SchoolPropertyType.Status;
};

export type StatusCategoryType =
  | 'prospective'
  | 'applied'
  | 'offered'
  | 'accepted'
  | 'current'
  | 'former'
  | 'unsuccessful';

export type SchoolTuneStatusType = Partial<Record<StatusCategoryType, SchoolProperty[]>>;
export interface SchoolTuneStatusesForm {
  students: SchoolTuneStatus[];
  staff: SchoolTuneStatus[];
}

export interface SchoolTuneStatusesArchivable {
  showArchived?: boolean;
  setShowArchived?: React.Dispatch<React.SetStateAction<boolean>>;
  autoSwitchedArchivedOn?: React.MutableRefObject<boolean>;
}
